import React from "react";
import { Outlet } from "react-router-dom";
import { useErrorPage } from "@hooks";

const OutletWithErrorHandling = () => {
  const ErrorPage = useErrorPage();

  if (ErrorPage) {
    return <ErrorPage />;
  }

  return <Outlet />;
};

export default OutletWithErrorHandling;
